/**
 * The recipes' default parameters, in a module of their own so the site can
 * import them without the recipe code behind them. The serving items set the
 * intermediary ceiling from these, and the pages say the same number.
 */
export const CO_FUNDING_DEFAULTS = { minimumSharedFunders: 2, maximumMembers: 50, maximumFanOut: 1000 } as const;
export const FUNDER_DISCOVERY_DEFAULTS = { neighbours: 25, minimumScore: 0.5, maximumMembers: 25 } as const;
